import * as generic from "@/store/generic/mutations/result-status.js";

export function clearError(state, payload) {
  generic.clearError(state, payload);
}

export function setError(state, payload) {
  generic.setError(state, payload);
}

export function setSuccess(state, payload) {
  generic.setSuccess(state, payload);
}

export function setProcessing(state, payload) {
  generic.setProcessing(state, payload);
}

export function setStudentAssignments(state, payload) {
  state.studentAssignments = payload ? payload : [];
}

export function setStudentAssignment(state, payload) {
  state.studentAssignment = payload;
}

export function purgeStudentAssignment(state) {
  state.studentAssignment.id = "";
  state.studentAssignment.classSection = null;
  state.studentAssignment.studentAssignment = null;
  state.studentAssignment.studentEnrollDetail = null;
  state.studentAssignment.student = null;
  state.studentAssignment.sectionNo = null;
  state.studentAssignment.studentCode = null;
  state.studentAssignment.remark = null;
  state.studentAssignment.studentSendDate = null;
  state.studentAssignment.isTeacherReceive = null;
  state.studentAssignment.score = null;
  state.studentAssignment.dueDate = null;
  state.studentAssignment.uploadPath = null;
  state.studentAssignment.uploadPathUri = null;
  state.studentAssignment.uploadFileName = null;

  state.studentAssignments = [];
  state.processing = false;
  state.error = null;
  state.success = null;
}
